import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HASH_REDIRECTS } from "../data/site";

export default function LegacyRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const raw = window.location.hash.replace(/^#\/?/, "").split("?")[0];
    if (!raw) return;
    const target = HASH_REDIRECTS[raw];
    if (target) navigate(target, { replace: true });
  }, [navigate]);

  return null;
}
